import { render } from "./cities-table.vue?vue&type=template&id=1d49f977"
import script from "./cities-table.vue?vue&type=script&lang=js"
export * from "./cities-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__